import Box from '@mui/material/Box';
import Slide from '@mui/material/Slide';
import { SxProps } from '@mui/system/styleFunctionSx';
import { useEffect, useRef, useState } from 'react';

type TextRevealProps = {
    text: string;
    sx?: SxProps;
};

export const TextReveal = ({ text, sx }: TextRevealProps) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [showAnimation, setShowAnimation] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setShowAnimation(true), 250);
        return () => clearTimeout(timer);
    }, []);

    return (
        <Box ref={containerRef} sx={{ overflow: 'hidden', height: { xs: '46px', md: '67px' }, ...sx }}>
            <Slide
                timeout={{ enter: 900 }}
                in={showAnimation}
                direction="up"
                container={containerRef.current}
                style={{ transitionTimingFunction: 'cubic-bezier(0.7, 0, 0.4, 1.4)' }}
            >
                <Box>{text}</Box>
            </Slide>
        </Box>
    );
};
